import { render, staticRenderFns } from "./SecurityProfile.vue?vue&type=template&id=612c86ac"
import script from "./SecurityProfile.vue?vue&type=script&lang=js"
export * from "./SecurityProfile.vue?vue&type=script&lang=js"
import style0 from "./SecurityProfile.vue?vue&type=style&index=0&id=612c86ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports